import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
// import config from '../../config'
import {GET_FILTER_LIST} from './actionTypes'
import fetchData, {fetchContent} from '../../utils/fetch-data'
// import {getCookie} from '../../utils/cookie'
import config from '../../config'



const useFilterListActions = () => {
  const dispatch = useDispatch()
  const getFilterListChoice = useCallback(
    (choice) => {
      dispatch({
        type: GET_FILTER_LIST,
        payload: choice
      })
    },
    [dispatch],
  )

  return {getFilterListChoice}
}

export default useFilterListActions

